import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function Guideline(props) {
  const {circular, guideline, borderColor, isVisible} = props;
  const classes = classnames('ndx-Guideline', {isVisible});

  const style = {
    left: guideline.left,
    top: guideline.top,
    width: guideline.width,
    height: guideline.height,
    color: borderColor,
    borderColor,
    borderRadius: circular ? '50%' : undefined
  };

  const circularH5Style = {
    width: '100%',
    textAlign: 'center',
    marginTop: guideline.height / 5
  };

  return (
    <div className={classes} style={style}>
      <h5
        className="ndx-guideline-title"
        style={circular ? circularH5Style : undefined}>
        {guideline.name}
      </h5>
    </div>
  );
}

const propTypes = {
  borderColor: PropTypes.string.isRequired,
  guideline: PropTypes.object.isRequired,
  circular: PropTypes.bool,
  isVisible: PropTypes.bool
};

Guideline.propTypes = propTypes;
